import { render } from "./ErrorAnimation.vue?vue&type=template&id=0f98af84&scoped=true"
const script = {}

import "./ErrorAnimation.vue?vue&type=style&index=0&id=0f98af84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f98af84"]])

export default __exports__